import appendQuery from 'append-query'
import queryString from 'query-string'
import { createRequest, } from '~/utils/api'
import localStorageConfig from '~/config/localStorageConfig'

export const getJobTitleSuggestions = ({ name, }) =>
  createRequest(
    {
      method: 'GET',
      url: appendQuery(
        '/autocomplete/job',
        queryString.stringify({
          name,
        }),
      ),
    },
    [
      'FrontEnd',
      'Backend',
      'FullStack',
      'Designer',
      'Lead',
      'FrontEnd1',
      'Backend1',
      'FullStack1',
      'Designer1',
      'Lead1',
      'FrontEnd2',
      'Backend2',
      'FullStack2',
      'Designer2',
      'Lead2',
      'FrontEnd3',
      'Backend3',
      'FullStack3',
      'Designer3',
      'Lead3',
      'FrontEnd4',
      'Backend4',
      'FullStack4',
      'Designer4',
      'Lead4',
      'FrontEnd5',
      'Backend5',
      'FullStack5',
      'Designer5',
      'Lead5',
      'FrontEnd6',
      'Backend6',
      'FullStack6',
      'Designer6',
      'Lead6',
      'FrontEnd7',
      'Backend7',
      'FullStack7',
      'Designer7',
      'Lead7',
      'FrontEnd8',
      'Backend8',
      'FullStack8',
      'Designer8',
      'Lead8',
      'FrontEnd9',
      'Backend9',
      'FullStack9',
      'Designer9',
      'Lead9',
    ],
  )

export const getLocationSuggestions = ({ name, }) =>
  createRequest(
    {
      method: 'GET',
      url: appendQuery(
        '/autocomplete/place',
        queryString.stringify({
          name,
        }),
      ),
    },
    ['Paris area', 'Los Angeles area, CA', 'Cleveland area, NY',],
  )

export const getInterestsSuggestions = ({ name, }) =>
  createRequest(
    {
      method: 'GET',
      url: appendQuery(
        '/autocomplete/tag',
        queryString.stringify({
          name,
        }),
      ),
    },
    ['Business', 'Dev',],
  )

export const getSearchResult = ({
  jobTitles,
  locations,
  includedCompanies,
  excludedCompanies,
  goals,
  interests,
  schools,
  experience,
  segment,
}) =>
  createRequest(
    {
      method: 'GET',
      url: appendQuery(
        '/search',
        queryString.stringify({
          job: jobTitles.length ? JSON.stringify(jobTitles) : undefined,
          city: locations.length ? JSON.stringify(locations) : undefined,
          company: includedCompanies.length
            ? JSON.stringify(includedCompanies)
            : undefined,
          excluded_terms: excludedCompanies.length
            ? JSON.stringify(excludedCompanies)
            : undefined,
          school: schools.length ? JSON.stringify(schools) : undefined,
          goal: goals.length ? JSON.stringify(goals) : undefined,
          tag: interests.length ? JSON.stringify(interests) : undefined,
          years_of_experience: experience.length
            ? JSON.stringify(experience)
            : undefined,
          segment: segment.length ? JSON.stringify(segment) : undefined,
        }),
      ),
    },
    {
      base64: btoa(`username,password,email,time
bob,12345678,test@somemail.com,1554804359`),
    },
  )
